import React from 'react';
import { NavLink } from 'react-router-dom';

import useIsFromMobileApp from 'hooks/useIsFromMobileApp.hook';
import { useTranslation } from 'providers/GILT.provider';

import SidebarMenu from '../components/menu/SidebarMenu.component';
import PadLock from '../lib/components/PadLock';

const determineMenuItems = (t) => [
  { segment: 'buckets', name: t('businessReports.topNavMenu.reports') },
  { segment: 'dashboard', name: t('businessReports.topNavMenu.weeklyDashboard') },
  { segment: 'monthly-dashboard', name: t('businessReports.topNavMenu.monthlyDashboard') },
  { segment: 'services', name: t('businessReports.topNavMenu.services') },
  { segment: 'revenue', name: t('businessReports.topNavMenu.revenue') },
  { segment: 'future-revenue', name: t('businessReports.topNavMenu.futureRevenue') },
  { segment: 'retail', name: t('businessReports.topNavMenu.retail') },
  { segment: 'commissions', name: t('businessReports.topNavMenu.commissions') },
  { segment: 'payments', name: t('businessReports.topNavMenu.payments') },
  { segment: 'hours', name: t('businessReports.topNavMenu.hours') },
  { segment: 'bookings', name: t('businessReports.topNavMenu.bookings') },
  { segment: 'downloadable', name: t('businessReports.topNavMenu.downloadable') },
];

const ReportsMenu = ({ salonId }) => {
  const { t } = useTranslation();
  const isFromMobile = useIsFromMobileApp();
  const linkToReport = ({ salonId, segment }) => `/salon/${salonId}/reports/${segment}`;

  const MENU_ITEMS = determineMenuItems(t).filter((item) => !(isFromMobile && item.segment === 'downloadable'));

  const mapper1 =
    (salonId) =>
    ({ segment, name }) => ({ name, pathname: linkToReport({ salonId, segment }) });
  const mapper2 = ({ pathname, name }, index) => ({ id: index + 1, name, to: { pathname } });

  const menuItemLink = MENU_ITEMS.map(mapper1(salonId))
    .map((item, index) => mapper2(item, index))
    .map(({ id, name, to }) => (
      <li key={id}>
        <NavLink to={to} className="label-menu-btn" activeClassName="selected">
          {name}
        </NavLink>
      </li>
    ));

  return (
    <header className="settings-header stock-global-nav">
      <SidebarMenu />
      <div className="global-nav">
        <div className="page-name text-mobile reports" />
        <nav className="menu-list">
          <ul className="ul-scroll-menu">{menuItemLink}</ul>
        </nav>
        <PadLock inMenu />
      </div>
    </header>
  );
};

export default ReportsMenu;
